import {  useState } from 'react';
import { validateRequired, validateEmail, ErrorMessage } from '../../utlis/function.js';
import CommonLoader from '../common/CommonLoader.jsx';
import { Eye, EyeOff } from 'lucide-react';

const ChangePasswordModal = ({
  onClose,
  onSave,
  isLoading
}) => {
  const [formData, setFormData] = useState({
    // currentPassword: '',
    newPassword: '',    
    oldPassword: '',
  });
  const[showPassword, setShowPassword] = useState(false);
  const[showConfirmPassword, setShowConfirmPassword] = useState(false);
  // const[ShowCurrentPassword, setShowCurrentPassword] = useState(false);
  const [errors, setErrors] = useState({});


  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateFields = () => {
    const newErrors = {};

    // if (!validateRequired(formData.currentPassword)) {
    //   newErrors.currentPassword = 'current password is required';
    // }

    // Validate password
    if (!validateRequired(formData.newPassword)) {
      newErrors.newPassword = 'New Password is required';
    } else if (formData.newPassword?.length < 6) {
      newErrors.newPassword = 'Password must be at least 6 characters';
    }

     if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = 'password does not match';
    } 

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async (e) => {
    e.preventDefault()
    if (!validateFields()) return;
    
   const success= await onSave(formData);
      if(success){
        onClose();
      }
  };

  return (
    <div className="fixed inset-0 bg-[#000000b5] flex items-center justify-center z-50">
      <div className="bg-white rounded-[20px] max-w-[624px] w-full mx-4 relative shadow-[0_4px_31.9px_11px_rgba(255,255,255,0.25)] animate-fade-in">
        {isLoading && <CommonLoader fullScreen />}

        <div className="p-8">
          <form autoComplete='off'>
          <div className='max-h-[80vh] overflow-y-auto'>
            {/* Title */}
            <h2 className="text-[28px] font-semibold text-black mb-2">Change Password</h2>

              {/* current password Field */}
            {/* <div className="mb-5 relative">
              <label className="block text-sm font-medium text-black mb-2">
                Current password <span className="text-red-500">*</span>
              </label>
              <input
                type={ShowCurrentPassword ? "text" : "password"}
                placeholder="Enter staff name"
                name='current-password'
                value={formData.currentPassword}
                onChange={(e) => handleInputChange("currentPassword", e.target.value)}
                className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                  errors.name ? "border-red-500" : "border-[#DADADA]"
                }`}
              />
              <button
                  type="button"
                  onClick={() => setShowCurrentPassword(!ShowCurrentPassword)}
                  className="absolute right-4 top-2/3 -translate-y-1/2 text-[#a0aec0] hover:text-[#06323A] transition-colors"
                >
                  {ShowCurrentPassword ? (
                    <EyeOff size={20} />
                  ) : (
                    <Eye size={20} />
                  )}
                </button>
              <ErrorMessage message={errors.currentPassword} />
            </div> */}

            {/* New password  Field */}
            <div className="mb-5 relative">
              <label className="block text-sm font-medium text-black mb-2">
                New password <span className="text-red-500">*</span>
              </label>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                autoComplete='off'
                value={formData.newPassword}
                onChange={(e) => handleInputChange("newPassword", e.target.value)}
                className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                  errors.emailid ? "border-red-500" : "border-[#DADADA]"
                }`}
              />
               <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-2/3 -translate-y-1/2 text-[#a0aec0] hover:text-[#06323A] transition-colors"
                >
                  {showPassword ? (
                    <EyeOff size={20} />
                  ) : (
                    <Eye size={20} />
                  )}
                </button>
              <ErrorMessage message={errors.newPassword} />
            </div>
         


      

            {/*Confirm Password Field */}
            <div className="mb-8 relative">
              <label className="block text-sm font-medium text-black mb-2">
               Confirm Password <span className="text-red-500">*</span>
              </label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Enter password"
                value={formData.confirmPassword}
                onChange={(e) => handleInputChange("confirmPassword", e.target.value)}
                className={`w-full h-[48px] px-4 rounded-full border focus:outline-none transition-colors ${
                  errors.password ? "border-red-500" : "border-[#DADADA]"
                }`}               
              />
               <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-4 top-2/3 -translate-y-1/2 text-[#a0aec0] hover:text-[#06323A] transition-colors"
                >
                  {showConfirmPassword ? (
                    <EyeOff size={20} />
                  ) : (
                    <Eye size={20} />
                  )}
                </button>
              <ErrorMessage message={errors.confirmPassword} />
            </div>
          </div>

          {/* Buttons */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 h-[52px] rounded-full border border-[#06323A] text-[#06323A] font-medium hover:bg-gray-50"
            >
              Cancel
            </button>

            <button
              onClick={handleSave}
              className="flex-1 h-[52px] rounded-full bg-[#0A3A44] text-white font-medium hover:opacity-90"
            >
              Save
            </button>
          </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;

